var render = function render(){var _vm=this,_c=_vm._self._c;return _c('common-dialog',{ref:"dialog",attrs:{"title":"New Shipment Note","width":30,"inputs-map":_vm.newNote,"input-value-change":_vm.valueChange,"save-cb":_vm.saveNewNote,"reset-inputs":_vm.resetInputs}})
}
var staticRenderFns = []

export { render, staticRenderFns }